import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { THEME_COLORS, LOADING_CONFIG } from './core/constants/branding.constants';
import { AccountService } from './core/services/account.service';
import { BUILD_INFO } from './core/constants/build-info';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, NgxSpinnerModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'maresias-painel';

  readonly spinnerConfig = {
    bdColor: THEME_COLORS.OVERLAY_BACKGROUND,
    color: THEME_COLORS.PRIMARY,
    type: LOADING_CONFIG.SPINNER_TYPE,
    size: LOADING_CONFIG.SPINNER_SIZE,
  };

  constructor(private accountService: AccountService) {}

  ngOnInit(): void {
    console.info(`[Maresias] Versão ${BUILD_INFO.version} · Commit ${BUILD_INFO.commit ?? 'local'}`);
    this.accountService.initSessionWatch();
  }
}
